import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge sigur de clase Tailwind (rezolvă conflicte, ex. "p-2 p-4" -> "p-4"). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
